var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"loading-animation"}},[(!_vm.state)?_c('div',{staticClass:"loading-animation"},[_c('div',{staticClass:"loading-animation__logo"},[_c('Logo')],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }